<template>
  <div class="toolbarWindow">
    <div class="toolbar">
      <!-- Toolbar -->
      <div class="toolbar">
        <!-- Loop through each section of the toolbarOptions array -->
        <div
          v-for="(section, sectionIndex) in toolbarOptions"
          :key="sectionIndex"
          class="optionSection"
        >
          <!-- Loop through each option of the current section -->
          <div
            v-for="(option, optionIndex) in section"
            :key="optionIndex"
            class="optionDiv"
          >
            <ToolbarOption
              :option="option"
              :open-picker="openPicker"
              :picker-data="pickerData"
              @toolbar-option-click="handleClick(option)"
              @color-picker-click="handleColorPickerClick(option)"
              @icon-picker-click="handleIconPickerClick(option)"
              @alignment-dropdown-click="handleAlignmentDropdownClick(option)"
              @alignment-dropdown-option-click="handleAlignmentDropdownOptionClick"
            />
          </div>
          <div
            v-show="toolbarOptions && sectionIndex !== toolbarOptions.length - 1"
            class="divider"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ToolbarOption from '@/components/InfoWindow/sections/Toolbar/ToolbarOption.vue';
import {ColorPickerOptions, IconPickerOptions, ToolbarOptions} from '@/services/GraphicService';
import type {PickerItem} from './types';

export default {
  name: 'InfoWindowToolbar',
  components: {
    ToolbarOption,
  },
  props: {
    toolbarData: {
      type: Object as () => {toolbarOptions: ToolbarOptions[][]},
      default: () => ({
        toolbarOptions: null,
      }),
    },
  },
  data() {
    return {
      openPicker: null as string | null,
      pickerData: [] as PickerItem[],
      toolbarOptions: null as ToolbarOptions[][] | null,
    };
  },
  watch: {
    toolbarData(newVal) {
      // Whenever toolbarData prop is updated, update local values
      this.initializeToolbar(newVal);
    },
  },
  beforeMount() {
    // Before mounting, initialize the local values
    this.initializeToolbar(this.toolbarData);
  },
  methods: {
    initializeToolbar(toolbar: {toolbarOptions: ToolbarOptions[][]}) {
      this.toolbarOptions = toolbar.toolbarOptions ?? [];
      this.closePickers();
    },
    closePickers() {
      this.openPicker = null;
      this.pickerData = [];
    },
    // Handles the click event on basic toolbar actions
    handleClick(option: ToolbarOptions) {
      this.closePickers();
      option.callback(option.action);
      this.$forceUpdate();
    },
    handleColorPickerClick(option: ToolbarOptions) {
      this.closePickers();
      option.pickers.forEach((picker) => {
        const colorPicker = new ColorPickerOptions(picker as ColorPickerOptions);
        this.pickerData.push(colorPicker);
      });
      this.openPicker = option.name;
    },
    handleIconPickerClick(option: ToolbarOptions) {
      this.closePickers();
      option.pickers.forEach((picker) => {
        const iconPicker = new IconPickerOptions(picker as IconPickerOptions);
        this.pickerData.push(iconPicker);
      });
      this.openPicker = option.name;
    },
    handleAlignmentDropdownClick(option: ToolbarOptions) {
      this.closePickers();
      this.pickerData = option.dropdownOptions;
      this.openPicker = option.action;
    },
    handleAlignmentDropdownOptionClick(callback: () => void) {
      callback();
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbarWindow {
  background-color: white;
  border-radius: 5px;
  border: 1px solid white;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.toolbar {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.optionSection {
  display: flex;
  flex-direction: row;
  padding-left: 4px;
}

.divider {
  height: 20px;
  border-right: 1px solid lightgray;
  margin-left: 4px;
  align-self: center;
}

.optionDiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
